#import "../fragments/email-fragment.graphql"

mutation UpdateEmail($payload: EmailShareAndCreateContactsInput!) {
    emailShareAndCreateContacts(input: $payload) {
        email {
            ...Email
        }
    }
}
